import React, { useEffect, useState, useCallback } from 'react';
import Styles from './OpenPage.styles.css';
import SearchBar from '../../NewComponent/SearchBar/SearchBar';
import Layout from "../../NewComponent/Layout/Layout";
import { Grid } from '@mui/material';
import { fetchOpenQuestions, getKeyTag, OpenTabSearchQuestions } from '../../API/api';
import { useSelector, useDispatch, } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import { Pagination, Spin, List } from 'antd';
import TabSearch from '../../NewComponent/TabSearch/tabSearch';
// import ExpertData from '../SearchPage/ExpertData';
import Tabs from '../SearchPage/Tabs';
import PaginationComp from '../../NewComponent/Pagination/Pagination';
import SelectComp from '../../NewComponent/Select/Select';
import MultiSelectOpen from './MultiSelectOpen';
import QuestionBox from '../../NewComponent/SeekerOpenTab/QuestionBox';
import KeyTagDataBox from "../KeyTermPage/KeyTagDataBox";
import debounce from "lodash.debounce";
export default function NewOpenPage() {
	const openState = useSelector((state) => state.openQuestions);
	const searchState = useSelector((state)=>state.search)
	const userState = useSelector((state) => state.user)
	const keyTagState = useSelector(state=>state.keyTag);
	const [results, setResults] = useState([]);
	const [dropwDownOpt, setDropDown] = useState(openState.sortOptions);
	const [hasNextPage, setHasNextPage] = useState(false);
	const [domainNames, setDomainNames] = useState([])
	const [domain, setDomain] = useState(openState.domainFilter);
	const [currentPage, setCurrentPage] = useState(1);
	const dispatch = useDispatch();
	const {
		openQuestionsData,
		openQuestionsDataLoading,
		getTabSearchOpenQuestions,
		updatePageNumberOpenTab,
		openQuestionsCount,
		isDataLoadingExpertOpen,
		getExpertOpenData,
		getOpenDataCountExpert,
		ownRecordsValue,
		updatePageNumberExpertOpenTab,
		sortFilterDefault,
		sortChangeOpenPage,
		filterDomainDataOpenTab,
		updatesortOpenOption,
		searchInputValue,
		getTagsInOpen
	} = bindActionCreators(Actions, dispatch);


	useEffect(() => {
			searchInputValue('');
			setDropDown(openState.sortOptions);
		setDomainNames(() => {
			let options = userState.visibleTopics.map((obj, ind) => {
				return { value: obj, label: obj }
			})
			return options;
		})
		openQuestionsDataLoading(true);
		if (openState.tabSearchValue === "") {
			fetchOpenQuestions(
				openState.pageNo,
				"open",
				openState.sortFilterVal.origValue,
				openState.sortFilterVal.sortOrder,
				openState.sortChange,
				openState.domainFilter,
			)
				.then((res) => {
					if (res === undefined) return;
					openQuestionsData(res.data.data);
					openQuestionsCount(res.data.count);
					openQuestionsDataLoading(false);
					setResults((prev) => [...prev, ...res.data.data]);
					setHasNextPage(Boolean(res.data.data.length));
					let quesTds = res.data.data.map((obj)=>obj.questionUuid)
					if (quesTds && quesTds.length > 0) {
						getKeyTag(quesTds)
					}
				})
				.catch((err) => console.log(err));
		} else if (openState.tabSearchValue !== "") {
			OpenTabSearchQuestions(
				openState.pageNo,
				"open",
				openState.sortFilterVal.origValue,
				openState.tabSearchValue,
				openState.sortFilterVal.sortOrder,
				openState.sortChange,
				openState.domainFilter
			)
				.then((res) => {
					if (res === undefined) return;
					openQuestionsData(res.data.data);
					openQuestionsCount(res.data.count);
					openQuestionsDataLoading(false);
				})
				.catch((err) => console.log(err));
		}
	}, [openState.pageNo,
	openState.tabSearchValue,
	openState.sortOrder,
	openState.domainFilter,
	openState.sortFilterVal,
	openState.reloadPage])

	const onChangeTabSearchVal = (e) => {
		if(e.target.value.length !== 0){
			// debouncedFetchOptions(e.target.value)
		sortChangeOpenPage(false)
		// onChangeValTab(e.target.value)
		if (isCheckRelevance(openState.sortOptions)) {
			getTabSearchOpenQuestions(e.target.value);
		} else {
			// let obj = [...openState.sortOptions];
			// obj.push(openState.relevanceObj);
			updatesortOpenOption(openState.sortOptions.concat([openState.relevanceObj]));
			sortFilterDefault(openState.relevanceObj);
			getTabSearchOpenQuestions(e.target.value);
		}

		// if(e.target.value.length === 0)
		// {
		// 	console.log('hello');
		// 	onClearValue()
		// }
		}
		if(e.target.value.length === 0){
			onClearValue();
		}
		// console.log(e.target.value);
	}

	// const debouncedFetchData = useCallback(debounce(onChangeTabSearchVal, 300), []);

	// const handleChange = (e) => {
  //   const value = e.target.value;
  //   debouncedFetchData(value); // Call the debounced function
  // };



	const onClearValue = () => {
		getTabSearchOpenQuestions('')
		sortChangeOpenPage(false);
		let sdf = [...openState.sortOptions]
		sdf.pop()
		sortFilterDefault(openState.sortOptions[0]);
		updatesortOpenOption(sdf)
		// let options = openState.sortOptions;
		// console.log(options, openState);
	}

	const onChangeValTab = (value) => {
		if (value.length > 4) {
			getTabSearchOpenQuestions(value)
		}
	}

	// const handleChange = (value) => {
	// 	// Pass the value to the debounced function
	// 	handleDebouncedChange(value.target.value);
	// 	if (value.target.value === "") {
	// 		onClearValue()
	// 	}
	// };


	const onChangeDropdown = (val) => {
		// sortFilterVal: { id:"1",value: "recently asked", label: "Recently Asked", origValue:'questionAsked', sortOrder:'desc' }
		let newObj = {
			id: "1", value: val, label: val === 'recently asked' ? 'Recently Asked' : 'Oldest Asked', origValue:'questionAsked', sortOrder: val === 'recently asked' ? 'desc' : 'asc'
		}
		sortFilterDefault(newObj)
		sortChangeOpenPage(true)
	}

	const styles =
		{ width: '60%', fontSize: '12px' }

		const isCheckRelevance = (str) => {
			let isThere = false;
			for (let i = 0; i < str.length; ++i) {
				if (str[i].label === "Relevance") {
					isThere = true;
				}
			}
			return isThere;
		};
const onChangeDomain = (e)=>{
     setDomain(e);
    debouncedFetchOptions(e)
  }
const debouncedFetchOptions = useCallback(
      debounce((value) => filterDomainDataOpenTab(value), 2000),
      []
    );
	return (
		<>
			<Layout>
				<div style={{ width: "74%", margin: "auto", marginTop: "1%", marginBottom: '7%' }}>
					<SearchBar />
					<Grid container style={{ backgroundColor: '#fff', marginTop: '4%', borderRadius: '12px', border: '1px solid #e0e2e6', padding: '24px' }}>
						{!keyTagState.isBack &&<>
						<div style={{
							fontSize: '16px',
							fontWeight: 500,
							lineHeight: '24px',
							textAlign: 'left',
							color: '#2A364A',
							width: '100%'
						}}>Open Question(s){" "}{openState.count !== undefined && openState?.count}</div>
						<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '7px', marginBottom: '15px', width: '100%',flexWrap:'wrap' }}>
							<div style={{ width: '280px' }}>
							<TabSearch size={"large"} val={openState.tabSearchValue} onChangeFunc={(e) => onChangeTabSearchVal(e)} />
							</div>
							<div style={{ display: 'flex', alignItems: 'center', width: '51%', justifyContent: 'end' }}>
							<div>
							{/* <span style={{fontSize:'14px',color:'#344054',fontWeight:400}}>Sort By </span> */}
							</div>
							&nbsp;&nbsp;
								<SelectComp
									isString={false}
									val={openState.sortFilterVal.value}
									// onChangeFunc={onChangeDropdown1}
									options={dropwDownOpt}
									width={"180px"}
									size={"large"}
									onChangeFunc={(e) => onChangeDropdown(e)}
								/>
								{/* <MultiSelect placeholder={" Select Domain"} options={domainNames} styles={styles} onChangeFunc={filterDomainDataOpenTab} /> */}
								&nbsp;&nbsp;
								<MultiSelectOpen value={domain} onChangeFunc={onChangeDomain} options={domainNames} />
							</div>
						</div>
						{/* <div style={{ width: '100%' }}>
							<TabsOpen />
						</div> */}
						{openState.isLoading === false && openState.openData.length > 0 && openState.openData.map((obj, ind) => {
							return (
								<>
									<div style={{width:'100%'}}>
									<QuestionBox data={obj} key={ind} />
									</div>
								</>
							)
						})}
						{openState.isLoading && (
							<>
								<div style={{width:'100%'}}>
								<Spin spinning={true} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
								</div>
							</>
						)}
						</>}
						{keyTagState.isBack && <KeyTagDataBox />}
					</Grid>
				</div>
			</Layout>
		</>
	)
}